/* eslint-disable camelcase */
import FetchErrorParagraph from 'components/common/FetchErrorParagraph'
import MaterialTable from 'components/dataTable/MaterialTable'
import { MRT_Row } from 'material-react-table'
import { TableData } from 'models'
import { UniversalVehicle } from 'models/universalData'
import React from 'react'
import { defaultUniversalVehicle } from 'utils/helpers/extractViewModels'
import { useLoading, useCheckData } from 'utils/hooks'
import { usePaginatedVehicles } from 'utils/hooks/queries/usePaginatedVehicles'
import useVehicleModal from 'utils/hooks/useVehicleModal'

const WaitingFilesPage = () => {
  const {
    data: waitingFilesTableData,
    isLoading,
    isError,
    totalCount,
    pagination,
    setPagination,
    isFetching,
    fetchAllPages,
  } = usePaginatedVehicles('waitingFiles')

  const { Loading } = useLoading()
  const { setOpenModal, VehicleModal } = useVehicleModal()
  const { dataAfterCheck, hasData } = useCheckData<UniversalVehicle>(
    waitingFilesTableData,
    defaultUniversalVehicle,
  )
  const [vehicleModalActiveId, setVehicleModalActiveId] = React.useState<string>('')

  const waitingFiles: Array<UniversalVehicle> = dataAfterCheck
  const tableRows: Array<UniversalVehicle> = hasData ? waitingFiles : []
  const displayedTitle = `Véhicule(s) en attente : ${hasData ? totalCount : 0}`

  const handleClick = (row: MRT_Row<TableData>) => {
    setVehicleModalActiveId(row.original.no as string)
    setOpenModal(true)
  }

  if (isLoading) return <Loading />
  if (isError) return <FetchErrorParagraph />

  return (
    <>
      <MaterialTable
        data={tableRows as TableData[]}
        title={displayedTitle}
        onClick={handleClick}
        paginationController={{
          state: pagination,
          onChange: setPagination,
          rowCount: totalCount,
          isFetching,
        }}
         onFetchAllPages={(pageSize, onProgress, signal) =>
          (fetchAllPages(pageSize, onProgress, signal) as Promise<TableData[]>)
        }
        stickyPagination
        constrainTableContainer
        emptyStateMessage="Aucun véhicule en attente."
      />

      <VehicleModal id={vehicleModalActiveId} onClose={() => setVehicleModalActiveId('')} />
    </>
  )
}

export default WaitingFilesPage
